module.exports = __webpack_public_path__ + "img/1.1fe5c67b.jpg";